import { AWIN_TRACKING_KEY } from '@daymade/common-lib/affiliates';
import { makeAutoObservable, observable } from 'mobx';

import { RootStore } from './RootStore';

export class UTMStore {
  root: RootStore;
  initialized = false; // Initialization flag
  utmParams: Record<string, string> = {};

  constructor(root: RootStore) {
    this.root = root;
    makeAutoObservable(this, {
      utmParams: observable,
      initialized: observable,
    });
  }

  initStoreOnClientSide = () => {
    const storedParams = localStorage.getItem('utm_params');
    if (storedParams) {
      this.utmParams = JSON.parse(storedParams);
    }
    const urlParams = new URLSearchParams(window.location.search);
    const query = Object.fromEntries(urlParams.entries());

    const newUTMParams = this.utmParamsFromQuery(query);

    this.utmParams = { ...this.utmParams, ...newUTMParams };
    localStorage.setItem('utm_params', JSON.stringify(this.utmParams));
    this.initialized = true;
  };

  clearUTMParameters = () => {
    this.utmParams = {};
    localStorage.removeItem('utm_params');
  };

  private utmParamsFromQuery(query: { [key: string]: string }): {
    [key: string]: string;
  } {
    // 'awc' is Awin's click reference query param - stored here alongside the utm_* params so it
    // travels through the same localStorage -> order.utmParams flow used for affiliate/ad attribution.
    return Object.keys(query)
      .filter((key) => key.startsWith('utm') || key === AWIN_TRACKING_KEY)
      .reduce((obj: any, key: string) => {
        obj[key] = query[key];
        return obj;
      }, {});
  }
}
